<template>
    <v-card>
        <v-card-title>
            <span class="headline">Reporte de Vendedores</span>
        </v-card-title>

        <v-card-text>
            <v-alert v-model="mostrar_alert" dismissible :type="type_alert">
                <template v-html="html_alert" />
            </v-alert>

            <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex xs12>
                        <GmapMap :center="positionMap" :zoom="zoom_map" style="width: 100%; height: 500px" ref="map_vendedores">
                            <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
                                <table v-if="infoContent.name">
                                    <tr>
                                        <td><b>Vendedor:</b></td>
                                        <td style="padding-left : 10px">{{infoContent.fullname}}</td>
                                    </tr>
                                </table>
                            </gmap-info-window>
                            <gmap-custom-marker v-for="vendedor in markersVendedoresFilter" :draggable="false" @click.native="marcarVendedor({email:vendedor.user_id, position:vendedor.position.geopoint})" :marker="{lat: vendedor.position.geopoint.latitude, lng: vendedor.position.geopoint.longitude}">
                                <v-icon v-if="vendedor_marcado && vendedor_marcado.email == vendedor.user_id" color="green">mdi-star</v-icon>
                                <v-icon v-else :color="vendedor.disponible ? 'primary' : 'gray'">mdi-map-marker-radius</v-icon>
                            </gmap-custom-marker>
                        </GmapMap>
                        <br>
                        <vendedores-firebase :items="vendedoresTable" @vendedor:marcar="marcarVendedor" :marcar_a="vendedor_marcado" />
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    import axios from 'axios';
    import GmapCustomMarker from "vue2-gmap-custom-marker";
    import ReporteVendedoresFirebase from '@components/reportes/ReporteVendedoresFirebase';

    import EventBus from "@/EventBus";
    import { db, firebaseSigninTg, firebaseSignoutTg } from "@/db";

    export default {
        name: "ReporteVendedoresPage",
        components: { "gmap-custom-marker": GmapCustomMarker, "vendedores-firebase": ReporteVendedoresFirebase },
        data() {
            return {
                positionMap: { lat: 0, lng: 0 },
                vendedor_marcado: null,
                zoom_map: 11,
                loading: false,
                mostrar_alert: false,
                type_alert: 'success',
                html_alert: '',
                vendedores: [],
                vendedores_info: [],
                db: null,
                map_bounds: false,
                //
                infoContent: {},
                infoWindowPos: {
                    lat: 0,
                    lng: 0
                },
                infoWinOpen: false,
                //optional: offset infowindow so it visually sits nicely on top of our marker
                infoOptions: {
                    pixelOffset: {
                        width: 0,
                        height: -35
                    }
                }
            }
        },
        computed: {
            markersVendedoresFilter() {
                return this.vendedores.filter(({ position }) => position.geopoint.latitude && position.geopoint.longitude)
            },
            vendedoresTable() {
                return this.vendedores.map(item => {
                    const vendedorData = this.vendedores_info.find(info => info.email === item.user_id);
                    return {
                        nombre_completo: (vendedorData) ? vendedorData.nombre_completo : '',
                        email: item.user_id,
                        disponible: item.disponible,
                        nuevo_pedido: item.nuevo_pedido,
                        pedido_activo: item.pedido_activo,
                        position: item.position.geopoint,
                        synced_at: vendedorData ? vendedorData.app_synced_at : null,
                        synced_at_for_humans: vendedorData ? vendedorData.app_synced_at_for_humans : null
                    };
                }).filter(item => (item.position && item.position.latitude));
            }
        },
        watch: {
            vendedores: {
                handler: function (value) {
                    if (!this.map_bounds) {
                        setTimeout(() => {
                            // this.panToBounds();
                            this.loadAppSyncedAppData()
                        }, 1500)
                    }
                },
            }
        },
        /*firestore : {
            vendedores : db.collection('localizaciones')
        },*/
        mounted() {
            window.navigator.geolocation.getCurrentPosition(({ coords }) => {
                this.positionMap.lat = coords.latitude;
                this.positionMap.lng = coords.longitude;
                this.zoom_map = 11;
            });

            firebaseSigninTg();
            EventBus.$on('firebase:auth', () => {
                console.log('event auth');
                const localizaciones = db.collection("localizaciones");
                setTimeout(() => {
                    this.$bind("vendedores", localizaciones);
                    setTimeout(() => {
                        this.vendedoresInfo();
                    }, 500)
                }, 500)
            });

        },
        beforeDestroy() {
            console.log('before destroy unbind')
            firebaseSignoutTg();
        },
        methods: {
            marcarVendedor(item) {
                if (!this.vendedor_marcado || (this.vendedor_marcado && this.vendedor_marcado.email != item.email)) {
                    this.vendedor_marcado = item;
                    this.positionMap.lat = item.position.latitude;
                    this.positionMap.lng = item.position.longitude;
                } else {
                    this.vendedor_marcado = null;
                    this.panToBounds();
                }
            },
            vendedoresInfo() {
                const correos = this.vendedores.map(item => {
                    return item.user_id;
                });
                if (correos.length == 0) {
                    return;
                }
                axios.get(`/api/reportes/vendedores/por-correo`, { params: { correos } }).then(({ data }) => {
                    this.vendedores_info = data;
                    this.mergeVendedorInfo()
                })
            },
            panToBounds() {
                this.$refs.map_vendedores.$gmapApiPromiseLazy().then(() => {
                    const b = new google.maps.LatLngBounds();
                    this.markersVendedoresFilter.map(vendedor => {
                        b.extend({
                            lat: vendedor.position.geopoint.latitude,
                            lng: vendedor.position.geopoint.longitude
                        });
                    })
                    this.$refs.map_vendedores.fitBounds(b);
                    this.$refs.map_vendedores.panToBounds(b);
                });
            },
        }
    }
</script>

<style scoped>

</style>